import { EssentialOption } from './essential-option';
import { AbstractGroup } from './abstract-group';
import { Logger } from './utilities/logger';
/**
 * Essential consent group, meaning it contains only consent options, that cannot be enabled or disabled by the user.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class EssentialGroup extends AbstractGroup {
    constructor(api, data) {
        super(api, data);
        this.options = {};
        Logger.debug('essential-group', `Starting to construct "${this.uid}".`);
        for (const identifier in data.options) {
            this.options[identifier] = new EssentialOption(this.api, this, data.options[identifier]);
        }
        Logger.debug('essential-group', `Finished constructing "${this.uid}".`);
    }
}
